/* @flow */
import { call, callRaw } from '../core';

export const callGetPendingUsers = (
  pageSize: number,
  page: number,
  sort: string,
  desc: boolean,
  search: string,
) =>
  callRaw('users/pending', 'GET', {
    params: {
      page_size: pageSize,
      page: page,
      sort_by: sort,
      desc: desc,
      search,
    },
  });

export const callVerifyUser = (id: string) =>
  call(`users/${id}/verify`, 'POST', {});

export const callRejectUser = (id: string) =>
  call(`users/${id}/reject-verification`, 'POST', {});
